import request from '@/utils/request'

// 조회
export function getRiskAssessmentOneCreationProcessWorkList(params, isNotify) {
  return request({
    url: '/api/getRiskAssessmentOneCreationProcessWorkList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
// 조회
export function getRiskAssessmentOneCreationList(params, isNotify) {
  return request({
    url: '/api/getRiskAssessmentOneCreationList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}

// 근로자 의견 조회
export function getRiskAssessmentOneCreationComment(params, isNotify) {
  return request({
    url: '/api/getRiskAssessmentOneCreationComment',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}

// 저장
export function saveRiskAssessmentOneCreation(params, isNotify) {
  return request({
    url: '/api/saveRiskAssessmentOneCreation',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}

// 삭제
export function deleteRiskAssessmentOneCreation(params, isNotify) {
  return request({
    url: '/api/deleteRiskAssessmentOneCreation',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved, deleted
  })
}

// 감소대책 타사사례 조회
export function getReduceSample(params, isNotify) {
  return request({
    url: '/api/getReduceSample',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}

// 근로자 의견 저장
export function saveRiskAssessmentOneCreationComment(params, isNotify) {
  return request({
    url: '/api/m/saveRiskFactorComment',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}

// 근로자 의견 삭제
export function deleteRiskAssessmentOneCreationComment(params, isNotify) {
  return request({
    url: '/api/m/deleteRiskFactorComment',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved, deleted
  })
}
